/* LECHUZA Canada – small accessibility helpers for Horizon's slideshow.
   - Autoplay never runs for visitors who ask for reduced motion (WCAG 2.2.2 / 2.3.3).
   - Autoplay pauses while keyboard focus is inside the slideshow and resumes when it leaves
     (unless the visitor pressed the pause button). */
(function () {
  if (!('customElements' in window)) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function wire(el) {
    if (el.__lechuzaWired || !el.hasAttribute('autoplay')) return;
    el.__lechuzaWired = true;
    if (reduce && reduce.matches && typeof el.pause === 'function') el.pause();
    el.addEventListener('focusin', function () {
      if (typeof el.suspend === 'function') el.suspend();
    });
    el.addEventListener('focusout', function (e) {
      if (el.contains(e.relatedTarget)) return;
      if (typeof el.resume === 'function') el.resume();
    });
  }

  // Keep keyboard focus out of off-screen slides: mirror Horizon's aria-hidden onto `inert`.
  function syncInert(el) {
    if (el.__lechuzaInert) return;
    el.__lechuzaInert = true;
    var apply = function () {
      el.querySelectorAll('slideshow-slide').forEach(function (s) {
        if (s.closest('slideshow-component') !== el) return;
        if (s.getAttribute('aria-hidden') === 'true') s.setAttribute('inert', '');
        else s.removeAttribute('inert');
      });
    };
    apply();
    new MutationObserver(apply).observe(el, { subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });
  }

  function init() {
    document.querySelectorAll('.slideshow-section slideshow-component').forEach(syncInert);
    document.querySelectorAll('slideshow-component[autoplay]').forEach(function (el) {
      // run after Horizon's own connectedCallback has started autoplay
      setTimeout(function () { wire(el); }, 0);
    });
  }

  customElements.whenDefined('slideshow-component').then(function () {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  });
  if (reduce && reduce.addEventListener) {
    reduce.addEventListener('change', function (e) {
      if (!e.matches) return;
      document.querySelectorAll('slideshow-component[autoplay]').forEach(function (el) {
        if (typeof el.pause === 'function') el.pause();
      });
    });
  }
})();
